<script lang="ts">
	import { Icon } from 'svelte-icons-pack';
	import { FaSolidSpinner } from 'svelte-icons-pack/fa';
</script>

<span class="m-1 animate-spin"><Icon src={FaSolidSpinner} /></span>
